
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.about-me-heading {

    margin-bottom: 1.5rem
}

.about-me-text {

    margin-bottom: 1.5rem;

    font-family: var(--ff-body);

    font-size: var(--fs-lg);

    line-height: var(--lh-lg)
}

@media (min-width: 768px) {

    .about-me-text {

        margin-bottom: 2.5rem
    }
}

.about-me-table-wrapper .row {

    width: 100%
}

@media (min-width: 480px) {

    .about-me-table-wrapper .row {

        display: flex
    }
}

.about-me-table-wrapper .row p {

    margin: 0px
}

@media (min-width: 480px) {

    .about-me-table-wrapper .row p {

        padding-bottom: 1rem
    }
}

.about-me-table-wrapper .row p:first-child {

    white-space: nowrap;

    padding-right: 2rem;

    font-weight: var(--fw-semibold)
}

.about-me-table-left {

    white-space: nowrap;

    padding-right: 2rem;

    font-weight: var(--fw-semibold)
}
`;